export default __webpack_public_path__ + "static/media/Boots of the Hell Walker.343cf3ad.jpg";